/**
 * Compatibilité zone <-> méthode d'impression.
 *
 * Une zone peut déclarer une liste de méthodes autorisées (`methods`). Règle :
 * une zone SANS méthode (absent ou vide) est réservée au NUMÉRIQUE (legacy =
 * compatible numérique par défaut). Une zone AVEC des méthodes n'est proposée
 * que pour celles-ci.
 */
export function zoneAllowsMethod(zoneMethods: unknown, method: string | null | undefined): boolean {
    const m = (method || 'digital').toLowerCase();
    if (!Array.isArray(zoneMethods) || zoneMethods.length === 0) {
        return m === 'digital'; // legacy : numérique uniquement
    }
    return zoneMethods.some((z) => String(z).toLowerCase() === m);
}
